export const KEYWORD_SEARCH_UPDATE = 'KEYWORD_SEARCH_UPDATE';
export const RESET_SEARCH_FILTERS = 'RESET_SEARCH_FILTERS';
export const UPDATE_SEARCH_SORT = 'UPDATE_SEARCH_SORT';
export const SET_SEARCH_FILTERS = 'SET_SEARCH_FILTERS';
export const APPLY_ADVANCED_FILTERS = 'APPLY_ADVANCED_FILTERS';
export const ADD_TO_ADVANCED_FILTER_LIST = 'ADD_TO_ADVANCED_FILTER_LIST';
export const REMOVE_FROM_ADVANCED_FILTER_LIST = 'REMOVE_FROM_ADVANCED_FILTER_LIST';
export const SET_ADVANCED_FILTER_LIST = 'SET_ADVANCED_FILTER_LIST';
export const SET_PRICE_RANGE = 'SET_PRICE_RANGE';
export const BATCH_ACTIONS = 'BATCH_ACTIONS';